module.exports = __webpack_public_path__ + "static/media/check-circle-green.b4cd5b8c.png";